import { ButtonHTMLAttributes, ReactNode } from 'react';
import { ButtonVariants, button } from './button.css';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  ButtonVariants & {
    children?: ReactNode;
    fullWidth?: boolean;
    flexNone?: boolean;
  };

/**
 * Primary UI component for user interaction
 */
export const Button = ({
  type = 'button',
  variant = 'solidPrimary',
  size = 'medium',
  fullWidth = false,
  children,
  flexNone = false,
  ...props
}: ButtonProps) => {
  return (
    <button
      type={type}
      className={button({
        variant,
        size,
        fullWidth,
        flexNone,
      })}
      {...props}>
      {children}
    </button>
  );
};
